import { ProductRangeCategoryInterface } from "../../../common/utils/productRange/mergeCategoriesWithProducts";
import { JSX, useState } from "react";
import { CategorySubItem } from "./CategorySubItem";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ProductListHeader } from "@hatch-digital-nl/bravilor-storybook";
import { openCategory, selectProduct } from "../ProductRangeSlice";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { useNavigate } from "react-router-dom";
import { SimpleProduct } from "../../../common/utils/productConverters";
import { ProductIndexItemInterface } from "../../../common/interfaces/apiV2/shared/ProductIndexItemInterface";
import { isLeafCategory } from "../../../common/utils/productRange/isLeafCategory";
import { CategoryProductListContainer } from "./CategoryProductListContainer";

interface Props {
    category: ProductRangeCategoryInterface;
    standardActive?: boolean;
}

export const CategoryItem = (props: Props): JSX.Element => {
    const { category, standardActive } = props;
    const { label, children, id } = category;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [active, setActive] = useState(standardActive ?? false);
    const isLeaf = isLeafCategory(category);
    const isExpanded = active || !!standardActive;

    const { disableCheckbox } = useAppSelector((state) => state.productRange);

    const handleToggle = (): void => {
        const nextActive = !isExpanded;
        setActive(nextActive);

        if (isLeaf && nextActive) {
            dispatch(openCategory(id));
        }
    };

    const handleProductSelect = (product: SimpleProduct): void => {
        dispatch(
            selectProduct(product.originalProduct as ProductIndexItemInterface),
        );
    };

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.originalProduct.id}`);
    };

    return (
        <div
            className={
                "c-products-list__item " + (isExpanded ? "is-active" : "")
            }
        >
            <ProductListHeader
                isActive={isExpanded}
                onToggle={handleToggle}
                label={label}
                showIcon={!standardActive}
                variant={"main"}
            />

            {children.length > 0 ? (
                <div
                    className={
                        "c-products-list__sub-items " +
                        (standardActive
                            ? "c-products-list__sub-items--standard-active"
                            : "")
                    }
                >
                    {children.map((child) => (
                        <CategorySubItem
                            key={"category-" + child.id}
                            child={child}
                            disableCheckbox={disableCheckbox}
                        />
                    ))}
                </div>
            ) : (
                <div className="c-products-list__sub-items">
                    <div className="c-products-list__sub-item is-active">
                        <CategoryProductListContainer
                            categoryId={id}
                            isExpanded={isExpanded}
                            onProductSelect={handleProductSelect}
                            onProductClick={handleProductClick}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
